import { appConfig } from '../../../../../../../config/customization';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    borderBottom: `1px solid ${appConfig.colors.bordersGray}`,
    width: '100%',
    height: '9vh',
    padding: 10,
    boxSizing: 'border-box'
  }
};
